import axios from "axios";

export const getRawData = async() => {
    console.log("Fetching sample data for demo users");
    try {
        const response = await axios.get("https://wol-data-4e9637f727fe.herokuapp.com/raw");
        const data = response.data;

        // Log sample data to see format
        if (data && data.length > 0) {
            console.log(`Received ${data.length} demo data points`);
            console.log("Sample raw data point:", data[0]);

            // Check types of the first data point to diagnose issues
            if (data[0]) {
                const firstPoint = data[0];
                console.log("Data types check:", {
                    accel_x: typeof firstPoint.accel_x,
                    accel_y: typeof firstPoint.accel_y,
                    accel_z: typeof firstPoint.accel_z,
                    gyro_x: typeof firstPoint.gyro_x,
                    gyro_y: typeof firstPoint.gyro_y,
                    gyro_z: typeof firstPoint.gyro_z
                });
            }
        } else {
            console.log("No demo data received or empty array");
        }

        // Process data to ensure all values are numeric
        const processedData = data.map(item => {
            // Use Number() for explicit number conversion, with defaults for missing values
            return {
                timestamp: item.timestamp,
                accel_x: Number(item.accel_x || 0.25),
                accel_y: Number(item.accel_y || -0.3),
                accel_z: Number(item.accel_z || 0.8),
                gyro_x: Number(item.gyro_x || 0.15),
                gyro_y: Number(item.gyro_y || -0.1),
                gyro_z: Number(item.gyro_z || 0.05),
                temperature: Number(item.temperature || 72),
                percentage: Number(item.percentage || 82)
            };
        });

        // Log a processed point to verify types
        if (processedData.length > 0) {
            const sample = processedData[0];
            console.log("Processed sample point:", {
                timestamp: sample.timestamp,
                accel_x: sample.accel_x + " (type: " + typeof sample.accel_x + ")",
                accel_y: sample.accel_y + " (type: " + typeof sample.accel_y + ")",
                gyro_x: sample.gyro_x + " (type: " + typeof sample.gyro_x + ")",
                gyro_y: sample.gyro_y + " (type: " + typeof sample.gyro_y + ")"
            });
        }

        return processedData;
    } catch (error) {
        console.error("Error fetching demo data:", error);
        // Return some fallback data in case of error
        return generateFallbackData();
    }
};

// Generate fallback data if the API fails
function generateFallbackData() {
    console.log("Generating fallback demo data");
    const data = [];
    const now = new Date();

    // Generate 50 data points with 1-minute intervals
    for (let i = 0; i < 50; i++) {
        const time = new Date(now.getTime() - i * 60000);

        // Create random values as numbers, not strings (avoid toFixed)
        const accel_x = Math.random() * 0.5;
        const accel_y = Math.random() * 0.5 - 0.25;
        const accel_z = Math.random() * 0.5 + 0.5;
        const gyro_x = Math.random() * 0.3;
        const gyro_y = Math.random() * 0.3 - 0.15;
        const gyro_z = Math.random() * 0.2 - 0.1;

        data.push({
            timestamp: time.toISOString(),
            accel_x: accel_x,
            accel_y: accel_y,
            accel_z: accel_z,
            gyro_x: gyro_x,
            gyro_y: gyro_y,
            gyro_z: gyro_z,
            temperature: Math.floor(68 + Math.random() * 10),
            percentage: Math.floor(75 + Math.random() * 20)
        });
    }

    // Log a sample point to verify values are numeric
    if (data.length > 0) {
        const sample = data[0];
        console.log("Generated fallback data sample:", {
            timestamp: sample.timestamp,
            accel_x: sample.accel_x + " (type: " + typeof sample.accel_x + ")",
            gyro_x: sample.gyro_x + " (type: " + typeof sample.gyro_x + ")"
        });
    }

    return data;
}